import { render, staticRenderFns } from "./ChannelItemAudioPlayer.vue?vue&type=template&id=be387b46&scoped=true"
import script from "./ChannelItemAudioPlayer.vue?vue&type=script&lang=js"
export * from "./ChannelItemAudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./ChannelItemAudioPlayer.vue?vue&type=style&index=0&id=be387b46&prod&lang=scss"
import style1 from "./ChannelItemAudioPlayer.vue?vue&type=style&index=1&id=be387b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be387b46",
  null
  
)

export default component.exports